import { h, Fragment } from 'preact';
import parse from 'html-react-parser';
import { useProduct } from './product-context';

const ProductDescription = () => {
  const { activeProduct } = useProduct();

  if (activeProduct.description === '') return;

  return (
    <div className="product-description pb-[30px] border-b-1 border-grey-400">
      <div className="text-h6">{parse(activeProduct.descriptionHtml)}</div>
      <div className="product-description__badges pt-[5px]">
        {activeProduct.tags
          .filter((tag) => tag.includes('product_pill'))
          .map((tag, index) => {
            return (
              <div
                key={index}
                className="inline-block bg-tan-100 text-h6 py-[5px] px-[15px] mr-[10px] mt-[10px] rounded-[30px]"
              >
                {tag.split('::')[1]}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ProductDescription;
